import type { TodoActionTelemetryData } from 'owa-todo-actions';

export const SPACES_ACTION_SOURCE = 'SpacesTaskAsset';

export const spacesTodoActionTelemetryData: TodoActionTelemetryData = {
    actionSource: SPACES_ACTION_SOURCE,
    viewType: 'Item',
};
